/**
 * A moldura das telas de entrada. No celular nao existe moldura: o formulario
 * e a tela, e cartao dentro de tela pequena so rouba largura. A partir do
 * tablet ele vira cartao, que e o que separa o conteudo do fundo.
 *
 * Titulo e opcional: na tela de entrar, "E-mail", "Senha" e o botao ja dizem
 * o que fazer - um titulo em cima seria a terceira vez.
 */
export function AuthPanel({
  title,
  description,
  children,
}: {
  title?: string;
  description?: string;
  children: React.ReactNode;
}) {
  return (
    <section className="w-full sm:rounded-card sm:border sm:border-border sm:bg-card sm:p-8 sm:shadow-sm">
      {title ? (
        <header className="mb-6">
          <h2 className="text-xl font-semibold tracking-tight">{title}</h2>
          {description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
        </header>
      ) : null}

      {children}
    </section>
  );
}
